import styled from "@emotion/styled";

export const Track = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 4px;

  background: #686c77;

  cursor: pointer;
`;

export const Buffered = styled.div`
  position: absolute;
  inset-block: 0;
  inset-inline-start: 0;

  block-size: 100%;

  background: #acaeb4;
`;

export const Played = styled.div`
  position: absolute;
  inset-block: 0;
  inset-inline-start: 0;

  block-size: 100%;

  background: #4585ff;
`;
